import { ErrorCode, TOAST } from 'constant';
// eslint-disable-next-line import/no-cycle
import { toast } from 'layout';
// eslint-disable-next-line import/no-cycle

import { mapError } from '.';
// eslint-disable-next-line import/no-cycle

const warningMessageCodes = ['ALL_COUNCIL_MEMBERS_SENT_EMAIL'];
const warningMessageSet = new Set(warningMessageCodes);

// eslint-disable-next-line import/prefer-default-export
export const catchError = (t, error, navigate = null) => {
  const errorType = error?.response?.data?.type || error?.response?.data?.code;

  if (navigate && errorType === ErrorCode.RESOURCE_FORBIDDEN) {
    navigate('/unauthorized');
  }

  if (navigate && errorType.includes('NOT_FOUND')) {
    navigate('/404', {
      state: {
        errorType,
      },
    });
  }

  const messageType = warningMessageSet.has(errorType) ? TOAST.WARN : TOAST.ERROR;

  toast(messageType, mapError(t, error));
};
